import styles from "./ProgressBar.module.scss";

type ProgressBarProps = {
  /**
   * Total steps of the progress bar.
   */
  totalSteps: number;

  /**
   * Current step of the progress bar, default is 1.
   */
  currentStep?: number;

  /**
   * Set className for ProgressBar, default is empty.
   */
  className?: string;
};

/**
 * ProgressBar component is used to show the progress of a process.
 *
 * ## Usage
 *
 * ```tsx
 * <ProgressBar totalSteps={5} currentStep={2} />
 * ```
 */
export const ProgressBar: React.FC<ProgressBarProps> = ({ currentStep = 1, totalSteps }) => {
  const currentProgress = Math.min(
    100,
    Math.max(0, Number(((currentStep * 100) / totalSteps).toFixed(1)))
  );

  return (
    <div className={styles.progressBar}>
      <div className={styles.progress} style={{ width: `${currentProgress}%` }} />
    </div>
  );
};

export default ProgressBar;
